import React, {useState} from "react"
import tw from "twin.macro"

import { useModal } from "../../_global/hooks/Modal"
import EloquaContactTSWidget from "../../fr/price/EloquaContactTSWidget"

import { ReactComponent as ContactWidget } from "../../../assets/fr/img/contact-widget/contact-circle.svg"
import { ReactComponent as BackArrowIcon } from "../../../assets/_global/icons/ic_white_arrow_back.svg"


const Contactsubmenu = (props) => {
    const dayOfTheWeek = new Date().toLocaleString('fr-FR', {  weekday: 'long' });
    const timeOfTheDay = new Date().toLocaleString('fr-FR').slice(11, 17).replace(/[:]/g, '')

    const isWeekend = dayOfTheWeek === 'samedi' || dayOfTheWeek === 'dimanche'
    const isClosed = !isWeekend && (+timeOfTheDay < 900 || +timeOfTheDay > 1830) 
    
    const { show, showModal: Modal } = useModal(0)
    const [showForm, setShowForm] = useState(false)
    return (
        <>
            <ContactWidget 
                css={tw`fixed hover:cursor-pointer hidden md:block`} 
                css={{zIndex:"110000", right: "30px", top: "300px"}} 
                onClick={show}
            />  
            <Modal size="xs" close="Fermer" contactWidget>
                {!showForm 
                ? <div>
                    <div css={tw`text-white`}>
                        <h3 css={tw`font-semibold text-xl`}>Bénéficiez d'un <br/>essai gratuit* d'un mois</h3>
                    </div>
                    <div
                        css={tw`mb-12 m-6 p-4 bg-white text-green-400 border border-grey-200 border-solid rounded-md shadow-md`}
                        css={{boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)", borderRadius: "4px"}}
                    >
                        <h4 css={tw`text-2xl font-bold mb-2`} css={isClosed && tw`text-grey-400`}>0805 220 189</h4>
                        {isClosed 
                            ? 
                                <p css={tw`text-xs text-red`}>Fermé actuellement, réouverture <br />lun-ven 9h à 19h</p>
                            : 
                                <>
                                <p css={tw`text-xs`}>Appel non surtaxé</p>
                                <p css={tw`text-xs`}>Un conseiller disponible maintenant</p>
                            </>
                        }
                    </div>
                    <div
                        css={tw`bg-white m-6 p-4`}
                        css={{boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.2)", borderRadius: "4px"}}
                    >
                        <button
                            css={tw`btn btn-sm btn-ghost whitespace-no-wrap px-7 py-6 mb-4`}
                            aria-label="Demandez une démo"
                            data-wa-link="Contact-widget"
                            onClick={() => setShowForm(true)}
                            >
                            <div css={tw`mt-px`}>
                                <div css={tw`pt-px font-semibold text-base`}>
                                    Être recontacté
                                </div>
                            </div>
                        </button>
                        <p css={tw`text-xs`}>Choisir un créneau durant nos horaires d’ouverture</p>
                    </div>
                    <div css={tw`text-grey-500 text-xs`}>
                        *Essai gratuit d’un mois non cumulable avec l’offre <br />
                        promotionelle en cours
                    </div>
                </div>
                :
                    <>
                        <BackArrowIcon
                            css={tw`w-5 h-5 fill-current text-white absolute left-0 hover:cursor-pointer`}
                            onClick={() => setShowForm(false)}
                        />                    
                        <div css={tw`text-white`}> 
                            Laissez-nous vos disponibilités et vos coordonnées, un conseiller vous recontactera
                        </div> 
                        <EloquaContactTSWidget />  
                    </>                      
                }
            </Modal>            
        </>
    )
}

export default Contactsubmenu
